import { MdSearch } from 'react-icons/md';
import { Icon, IconContainer } from '@nbirl/nbi-common-ui-libs';

export const DashboardsSearchEmpty = () => (
  <div className="flex flex-col items-center space-y-2 px-6 py-28">
    <IconContainer variant="light">
      <Icon icon={<MdSearch className="text-primary-500" />} />
    </IconContainer>
    <p className="text-2xl font-medium">No matches found</p>
    <p className="text-center">
      There weren’t any workbooks matching your search.
    </p>
    <p className="text-center">Please try searching with another name.</p>
  </div>
);
